// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"30164d66","105":"b0fd1b1b","225":"1adb634d","270":"de734c38","631":"1b53ffef","771":"3069c555","804":"2484a756","952":"3e1a6c0d"}[chunkId] + ".chunk.js";
};